import styled from 'styled-components';
import {Button, Space} from 'antd';
import InvoiceAttachmentPreview from '../../TransactionsPage/InvoiceAttachmentPreview';
import {bordersStyles} from '../../../../utils/styles';

const StyledInvoiceDocumentCard = styled(Space)`
  ${bordersStyles.light};

  background-color: ${props => props.theme.colors.neutral_1};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 24px 16px;
  width: 100%;

  /* Make ant-space items stretch to fill the card */
  .ant-space-item {
    align-self: center;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

const StyledInvoiceDocumentCardPreview = styled(InvoiceAttachmentPreview)`
  max-height: unset;
`;

const StyledInvoiceDocumentCardButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 0;

  svg {
    height: 24px;
    width: 24px;
    path {
      fill: ${props => props.theme.colors.neutral_8};
      stroke: ${props => props.theme.colors.neutral_8};
      transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    }
  }

  &:not(:disabled):not(.ant-btn-disabled):not(.ant-btn-primary) {
    &:hover,
    &:active,
    &:focus {
      background-color: ${props => props.theme.colors.neutral_2};
      color: ${props => props.theme.colors.neutral_8};

      svg {
        path {
          fill: ${props => props.theme.colors.neutral_10};
          stroke: ${props => props.theme.colors.neutral_10};
        }
      }
    }
  }

  &.ant-btn-disabled,
  &:disabled {
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_4};
        stroke: ${props => props.theme.colors.neutral_4};
        transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
      }
    }
  }

  &.ant-btn-primary {
    svg {
      height: 24px;
      width: 24px;
      path {
        fill: ${props => props.theme.colors.neutral_1};
        stroke: ${props => props.theme.colors.neutral_1};
        transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
      }
    }

    &:not(:disabled):not(.ant-btn-disabled) {
      &:hover,
      &:active,
      &:focus {
        svg {
          path {
            fill: ${props => props.theme.colors.neutral_1};
            stroke: ${props => props.theme.colors.neutral_1};
          }
        }
      }
    }
  }
`;

export {
  StyledInvoiceDocumentCard,
  StyledInvoiceDocumentCardPreview,
  StyledInvoiceDocumentCardButton,
}
